import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLightTheme = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M9.91667 19.0833V18.25M3.43485 16.3985L4.02411 15.8092M0.75 9.91667H1.58333M3.43485 3.43485L4.02411 4.02411M9.91667 1.58333V0.75M15.8092 4.02411L16.3985 3.43485M18.25 9.91667H19.0833M15.8092 15.8092L16.3985 16.3985M14.9167 9.91667C14.9167 12.6781 12.6781 14.9167 9.91667 14.9167C7.15524 14.9167 4.91667 12.6781 4.91667 9.91667C4.91667 7.15524 7.15524 4.91667 9.91667 4.91667C12.6781 4.91667 14.9167 7.15524 14.9167 9.91667Z",
		stroke: "#71717A",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgLightTheme);
export default ForwardRef;
